import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/core/user/user.service';
import { User } from 'src/core/user/user.types';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  rolVet = '[ROLE_SUSCRIPTOR]';
  rolClient = '[ROLE_CLIENTE]';
  version: string = environment.version;
  public currentYear = new Date().getFullYear();
  userSession = {} as User;

  constructor(
    private _userService: UserService,
  ){
  }
  ngOnInit(): void {
    this.getUserSession();
  }

  getUserSession(){
    this._userService.user_session$.subscribe({
      next: (user: User) => {
        this.userSession = user;
      },
      error: (error: any) => {
      }
    });
  }
}
